export const extractDependsOn = (rules: any[]) => {
  let dependsOn: string[] = [];
  rules.forEach((rule: any) => (dependsOn = dependsOn.concat(rule.dependsOn)));
  return dependsOn;
};
